
const acessoGridConfig = {
  idField: "idAcesso",
  serviceMethod: "getPermissoes",
  columns: [
    { header: "Usuário", field: "NOME" },
    { header: "Perfil", field: "nome" },
    { header: "Descrição", field: "descricao" }
  ]
};

export default acessoGridConfig;


